// Données d'un écran admin : l'endpoint reçoit les mêmes paramètres de
// recherche que l'URL de la page (filtres).
import { useLocation } from "react-router";
import { useView } from "./view";

export function useAdminView<T>(path: string, options?: { keepPrevious?: boolean }) {
  const { search } = useLocation();
  return useView<T>(`${path}${search}`, options);
}
